import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { OptionType } from '@evinced-private/ui-common';

import { getWfaUserOptions } from 'src/apps/wfa/services/WfaDashboardService';
import { WFA_USER_OPTIONS } from 'src/common/providers/reactQueryProvider/QueryKeys';

export const useWfaUserOptionsQuery = (): UseQueryResult<OptionType[]> => {
	const sessionDetailsQuery = useQuery([WFA_USER_OPTIONS], () => getWfaUserOptions());

	return sessionDetailsQuery;
};
